/** @flow */
/** @module utils/currency/stringToNumber */
export default function stringToNumber(string, defaultVal = '') {
  const preparse = string.replace(/[^-\d]+/g, '');
  if (isNaN(preparse)) return defaultVal;
  return parseFloat(preparse);
}
